import React, { useEffect, useMemo, useState } from 'react';
import './ProfileDetailsContent.css'
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { createB2BAPI } from '../../../api/Interceptor';
import { useNavigate } from 'react-router-dom';
import Navigation from '../sidebar/Navigation';
import { Badge, Button, Input, Loader, Modal } from '@mantine/core';
import notify from '../../../utils/Notification';


const ProfileDetailsContent = () => {
    const userId = JSON.parse(localStorage.getItem('user'))?.userId
    const isCustomer = typeof userId === "string" && userId.startsWith("CUST-");
    const isVendor = typeof userId === "string" && userId.startsWith("VEN-") || /^B\d+$/.test(userId);
    const [profile, setProfile] = useState({});
    const [editprofile, setEditProfile] = useState(profile)
    const isMobile = useMediaQuery('(max-width: 767px)');
    const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const [opened, { open, close }] = useDisclosure(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {

        fetchAllProfile();
    }, []);

    const fetchAllProfile = async () => {
        try {
            setLoading(true); // start loader

            const res = await B2B_API.get(isCustomer ? 'customer/profile' : `vendor/${userId}`);
            const data = await res.json();

            let profileData = data?.response || {};

            if (profileData.assignedBuyer) {
                const buyerRes = await B2B_API.get(`user/${profileData.assignedBuyer}`);
                const buyerData = await buyerRes.json();
                profileData = {
                    ...profileData,
                    salesMan: {
                        email: buyerData?.response?.emailId,
                        mobile: buyerData?.response?.mobileNumber
                    }
                };
            }

            setProfile(profileData || []);
        } catch (error) {
            console.error('Error fetching profile:', error);
        } finally {
            setLoading(false); // stop loader
        }
    };


    const submitHandler = async () => {
        try {
            let update = editprofile
            if (editprofile.vendorId) {
                update = {
                    ...editprofile,
                    supplier: editprofile.companyName || editprofile.supplier,
                    mobileNumber: editprofile.mobileNo || editprofile.mobileNumber

                }
            }
            if (update?.vendorId) {
                const formData = new FormData();
                formData.append(
                    "vendorDto",
                    new Blob([JSON.stringify(update)], {
                        type: "application/json",
                    }))
                const customerResponse = await B2B_API.post("vendor/save", {
                    body: formData
                }).json();
                fetchAllProfile()
                close()
                return

            }
            await B2B_API.post(`customer/save`, { json: editprofile }).json();
            fetchAllProfile()
            close()
        } catch (error) {
            notify({
                id: "profile update",
                success: false,
                error: true,
                color: 'red',
                title: 'Profile Update',
                message: error.message || "Failed to update profile."
            });
        }
    };

    const handleSignOut = () => {
        localStorage.clear();
        navigate("/");
    };
    const handleEdit = () => {
        setEditProfile(profile)
        open();
    };
    return (
        <div className="view-my-page router-view-container">

            {loading && (
                <div className="loading-container">
                    <Loader color={"var(--primary)"} type="oval" />
                </div>
            )}
            {(!isMobile && !isTablet) && (
                <Navigation />
            )}

            <div className="view-account route-view">
                <div className="sections">
                    <div className="profile-section upper">
                        <div className="flex">
                            <div className="pages-title flex-wrap m-b-32" style={{ display: 'flex', alignItems: 'center' }}>Profile &nbsp;&nbsp; <Badge size="lg" color='blue'>{profile.approveStatus === 'DRAFT' ? 'Verification Pending' : profile.approveStatus}</Badge></div>
                            <div className="profile-box">
                                {/* <div style={{marginLeft: "260px", position: "absolute"}} >Approved Status</div> */}
                                <i className="fa fa-user"></i>

                                <div className="key-value">
                                    <div className="key">Company Name</div>
                                    <div className="value max-length">{profile?.companyName || profile?.supplier}</div>
                                </div>
                                <div className="key-value">
                                    <div className="key">Name</div>
                                    <div className="value">{profile?.username || profile?.name || 'N/A'}</div>
                                </div>
                                <div className="key-value">
                                    <div className="key">Email</div>
                                    <div className="value">{profile?.email || 'N/A'}</div>
                                </div>
                                <div className="key-value">
                                    <div className="key">Mobile Number</div>
                                    <div className="value">
                                        <span className="m-r-4">+91</span>
                                        <span>{profile?.mobileNumber || profile?.mobileNo || 'N/A'}</span>
                                    </div>
                                </div>
                                <div className="action-label" onClick={handleEdit}>
                                    Edit <i className="fal fa-chevron-right f-12" onClick={handleEdit}></i>
                                </div>
                            </div>
                        </div>
                        <Modal
                            opened={opened}
                            onClose={() => {
                                close();
                            }}
                            title="Edit Profile"
                            styles={{ title: { fontSize: '20px' } }}
                        >
                            <div className="body">
                                <div className="form-address">
                                    <div className="form-control required field-nickname" style={{ gap: "0px" }}>
                                        <label className="flex-row items-center m-b-4">
                                            <span className="flex-wrap"> Company Name</span>
                                        </label>
                                        <Input
                                            name="nickname"
                                            maxlength="20"
                                            value={editprofile.companyName || editprofile.supplier}
                                            onChange={(e) => setEditProfile({ ...editprofile, companyName: e.target.value })}
                                        />
                                    </div>
                                    {!editprofile.vendorId && <div className="form-control required" style={{ gap: "0px" }}>
                                        <label className="display-block">Name</label>
                                        <Input
                                            value={editprofile.name}
                                            onChange={(e) => setEditProfile({ ...editprofile, name: e.target.value })}
                                        />

                                    </div>}
                                    <div className="form-control required field-street-1" style={{ gap: "0px" }}>
                                        <label className="flex-row items-center">
                                            <span className="flex-wrap"> Email</span>
                                        </label>
                                        <Input
                                            name="email"
                                            placeholder="Email"
                                            maxlength="45"
                                            disabled='true'
                                            value={editprofile.email || ''}
                                            onChange={(e) => setEditProfile({ ...editprofile, email: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-control field-street-2" style={{ gap: "0px" }}>
                                        <label className="flex-row items-center">
                                            <span className="flex-wrap">Mobile Number</span>
                                        </label>
                                        <Input
                                            name="Mobile Number"
                                            placeholder="Mobile Number"
                                            maxlength="45"
                                            value={editprofile.mobileNo || editprofile.mobileNumber || ''}
                                            onChange={(e) => setEditProfile({ ...editprofile, mobileNo: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="bottom-buttons">
                                    <Button variant="default" onClick={() => close()}>Cancel</Button>
                                    <Button variant="filled" color='#8BC53F' onClick={submitHandler}>Update</Button>
                                </div>
                            </div>
                        </Modal>

                        <div className="sourcing-manager-wrapper">
                            <div className="pages-title m-b-32">Sourcing Manager</div>
                            <div className="sourcing-manager">
                                {profile?.salesMan || profile?.buyerName ? (<div className="sourcing-manager-content">
                                    <div className="adaptive-layout boundary-width-768" style={{ gap: '48px' }}>
                                        <div className="sourcing-manager-info-wrapper">
                                            <div >
                                                <div class="f-20 f-600">Hi {profile?.name || profile?.supplier || 'N/A'}.</div>
                                                <br />
                                                My name is <b> {profile?.salesMan?.name || profile?.buyerName}</b>
                                                <br />
                                                and I’m your personal sourcing manager at FabInsta.
                                                <br /><br />
                                                I’m here to help keep your sourcing simple and streamlined.
                                                <br /><br />
                                                Feel free to contact me at any time!
                                            </div>

                                        </div>
                                        <div className="sourcing-manager-image-wrapper flex-wrap text-center">
                                            <img
                                                className="display-table m-a"
                                                src="https://www.shutterstock.com/image-vector/vector-flat-illustration-grayscale-avatar-600nw-2264922221.jpg"
                                                alt={profile?.salesMan?.name}
                                            />
                                            <div className="f-600 c-gray-800">{profile?.salesMan?.name}</div>
                                        </div>
                                    </div>

                                    <div className="sourcing-manager-link-wrapper">
                                        <div className="sourcing-manager-link">
                                            <i className="fal fa-envelope"></i>
                                            <a href={`mailto:${profile?.salesMan?.email}`}>{profile?.salesMan?.email}</a>
                                        </div>
                                        <div className="sourcing-manager-link">
                                            <i className="fab fa-whatsapp"></i>
                                            <div className="adaptive-layout boundary-width-768 flex-fill" style={{ gap: '8px' }}>
                                                <div className="flex-wrap">{profile?.salesMan?.mobile}</div>
                                                <a
                                                    className="whatsapp-link"
                                                    href={`https://api.whatsapp.com/send/?phone=${profile?.salesMan?.mobile}&text=Hi!&app_absent=0`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Message me on WhatsApp!
                                                </a>
                                            </div>
                                        </div>
                                        <div className="c-gray-400 f-12 p-l-32">
                                            <div>
                                                <i className="fal fa-exclamation-circle m-r-8"></i>WhatsApp number is for text messaging only.
                                            </div>
                                            <div>
                                                <i className="fal fa-exclamation-circle m-r-8"></i>Group chat is not supported.
                                            </div>
                                        </div>
                                    </div>
                                </div>) : (
                                    <div className='sourcing-manager-content'>Source manager Not Yet Assigned</div>)}

                            </div>
                        </div>
                    </div>
                </div>
                {isMobile && (<button class="btn btn-secondary btn-signout" onClick={handleSignOut} >Sign out</button>)}
            </div>
        </div>
    );
}

export default ProfileDetailsContent;
